/* eslint-disable @typescript-eslint/no-useless-constructor */
import videojs from 'video.js';

const ClickableComponent = videojs.getComponent('ClickableComponent');

export type PosterSource = {
  src: string;
  set: PosterSetSource[];
};

export type PosterSetSource = {
  src: string;
  media: string;
};

export class Poster extends ClickableComponent {
  el_!: HTMLElement; // its a property of the parent class and the result of the createEl() function, TS is not able to detect it

  constructor(player: videojs.Player, options: videojs.ComponentOptions) {
    super(player, options);
  }

  dispose() {
    super.dispose();
  }

  createEl(): Element {
    return videojs.dom.createEl('div', { className: 'vjs-poster' });
  }

  setSrc(source?: PosterSource) {
    this.createPoster(source);

    if (source) {
      this.show();
    } else {
      this.hide();
    }
  }

  createPoster(source?: PosterSource) {
    if (!source?.src) {
      this.el_.textContent = '';
      return;
    }

    let picture = this.$('picture');

    if (!picture) {
      picture = videojs.dom.createEl('picture', {
        className: 'vjs-poster',
        tabIndex: -1,
      });

      this.el_.appendChild(picture);
    }
    picture.textContent = '';

    source.set.forEach((set) => {
      picture.appendChild(
        videojs.dom.createEl('source', {
          srcset: set.src,
          media: set.media,
        })
      );
    });

    picture.appendChild(
      videojs.dom.createEl(
        'img',
        {
          src: source.src,
        },
        {
          alt: '',
        }
      )
    );
  }

  handleClick(_event: Event) {
    // We don't want a click to trigger playback when controls are disabled
    if (!this.player_.controls()) {
      return;
    }

    if (this.player_.tech(true)) {
      this.player_.tech(true).focus();
    }

    if (this.player_.paused()) {
      this.player_.play()?.then(null, () => {
        //silence uncaught errors
      });
    } else {
      this.player_.pause();
    }
  }
}

videojs.registerComponent('miPoster', Poster);
